import LangEnum from '../../../lang/LangEnum';
import { Option } from '../../../lib/OptionsLib';
import { useTranslation } from '../../translation/TranslationContext';
import { StatusType } from '../order.types';

const useOrderStatusOptions = () => {
  const { translate } = useTranslation();

  const options: Array<Option & { value: StatusType }> = [
    {
      label: translate(LangEnum.ORDER_STATUS_SUGGESTED),
      value: StatusType.SUGGESTED,
    },
    {
      label: translate(LangEnum.ORDER_STATUS_DRAFT),
      value: StatusType.DRAFT,
    },
    {
      label: translate(LangEnum.ORDER_STATUS_IN_REVISION),
      value: StatusType.IN_REVISION,
    },
    {
      label: translate(LangEnum.ORDER_STATUS_ON_APPROVAL),
      value: StatusType.ON_APPROVAL,
    },
    {
      label: translate(LangEnum.ORDER_STATUS_APPROVED),
      value: StatusType.APPROVED,
    },
    {
      label: translate(LangEnum.ORDER_STATUS_SENT),
      value: StatusType.SENT,
    },
    {
      label: translate(LangEnum.ORDER_STATUS_CANCELED),
      value: StatusType.CANCELED,
    },
    {
      label: translate(LangEnum.ORDER_STATUS_ABANDONED),
      value: StatusType.ABANDONED,
    },
    {
      label: translate(LangEnum.ORDER_STATUS_REJECTED),
      value: StatusType.REJECTED,
    },
  ];

  return options;
};

export default useOrderStatusOptions;
